import React, { useEffect } from 'react'
import SurveysTable from '../Surveys/SurveysTable'
import { Grid } from '@material-ui/core'
import Auth from '../../services/auth'
import {makeStyles} from '@material-ui/core/styles'
import useAppState from '../../services/useAppState'

const useStyles = makeStyles({
  root: {
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px'
  },
  selected: {
    backgroundColor: 'rgb(56, 52, 150)'
  }
})

export default function Surveys () {
  const classes = useStyles()
  const {organization} = useAppState()

  useEffect(() => {
  }, [organization.id])

  return (
    <div>
      <Grid spacing={2}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <SurveysTable organizationId={Auth.isRole('owner') ? organization.id : ''} />
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}